/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const TIMER = project.getFeature(feature.getSettingValue('TIMER'));
    const TIMER_VAR = TIMER?.getSettingValue('TIMER_NAME');
    if (!TIMER) {
        return blocks;
    }
    const TIMER_NAME = `timer_${TIMER_VAR}`;

    const doneLinks = project.getNodeLinks(feature, 'done');
    const doneBlock = doneLinks.length > 0 ? `'****${doneLinks[0].getSourceId()}****'` : '';
    const links = project.getNodeLinks(feature, 'timer_stop');
    for (let i = 0; i < links.length; i++) {
        const link = links[i];

        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
${TIMER_NAME}=0
${doneBlock}
`,
        });
    }

    return blocks;
};
